import { render } from "./UserSetting.vue?vue&type=template&id=4ed89dfa&scoped=true"
import script from "./UserSetting.vue?vue&type=script&lang=js"
export * from "./UserSetting.vue?vue&type=script&lang=js"

import "./UserSetting.vue?vue&type=style&index=0&id=4ed89dfa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ed89dfa"]])

export default __exports__